import { render, staticRenderFns } from "./UpdateCustomer.vue?vue&type=template&id=61325496&scoped=true&"
import script from "./UpdateCustomer.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomer.vue?vue&type=style&index=0&id=61325496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61325496",
  null
  
)

component.options.__file = "UpdateCustomer.vue"
export default component.exports